/**
 * EncounterSlice Extra Reducers
 * 
 * Handles async actions from RTK Query endpoints.
 */

import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { EncounterSliceState } from './state';
import { encounterEndpoints } from '../endpoints/encounterEndpoints';

/**
 * Builds extra reducers for encounter API endpoint matchers.
 */
export function buildEncounterExtraReducers(builder: ActionReducerMapBuilder<EncounterSliceState>) {
  builder.addMatcher(
    encounterEndpoints.endpoints.getEncounter.matchFulfilled,
    (state, action) => {
      state.currentEncounter = action.payload;
      state.isEdited = false;
      state.editedFields = [];
      state.validationErrors = {};
    }
  );
}
